import { message, Spin } from "antd";
import { useContext, useState } from "react";
import { ForgotPasswordContext } from "../../../context/forgotPasswordContext";
import { mensajes_error } from "../../../data/data";
import {
	forgotPassword,
	forgotPasswordByCuit,
	validateCode
} from "../../../services/services";
import AuthHeader from "../../authentication/authHeader";
import ForgotPasswordFormStep from "../forgotPasswordFormStep/forgotPasswordFormStep";
import FormButton from "./../../common/form/formButton";
import VerificationCodeInput from "./verificationCodeInput/verificationCodeInput";

const VerificationCodeForm = () => {

	const {recoveryByCuit, value, dataResponseStep:dataFromPreviousStep } = useContext(ForgotPasswordContext);

	const emailToShow = recoveryByCuit? dataFromPreviousStep : value;

    const validateVerificationCode = (values) => {
        const { nro0, nro1, nro2, nro3 } = values;
        const code = `${nro0}${nro1}${nro2}${nro3}`;
        return code.length === 4
            ? validateCode((recoveryByCuit ? {email:null,cuit:value} : {email:value,cuit:null}), code)
            : new Promise((_, rej) => rej());
    };

    const success = () =>
        message.success(`Enviamos un nuevo código a ${emailToShow}`);

    const error = () => message.error(mensajes_error.EMAIL_FORM_STEP_500);

    const [loadingResendCode, setLoadingResendCode] = useState(false);

    const resendVerificationCode = () => {
        setLoadingResendCode(true);
		const recoverFn = recoveryByCuit ? forgotPasswordByCuit : forgotPassword;
		recoverFn(value)
            .then((res) => {
                setLoadingResendCode(false);
                success();
            })
            .catch((err) => {
                setLoadingResendCode(false);
                error();
            });
    };


    const verificationCodeFormHeader = (
        <AuthHeader title='Ingreso de codigo'>
        	 <p className='forgotPassword-text'>
                Ingresá el codigo de 4 dígitos que recibiste en el mail <br />
				<span className='bold'>{emailToShow}</span>
            </p>
        </AuthHeader>
    );

    return (
        <>
            <ForgotPasswordFormStep
                FormStepHeader={verificationCodeFormHeader}
                formStepCallback={validateVerificationCode}
            >
                <VerificationCodeInput />

                <FormButton>Continuar</FormButton>
                <div style={{ marginTop: "5px", marginBottom: "20px" }}>
                    <Spin spinning={loadingResendCode} tip='Reenviando código'>
                        No recibiste el código?
                        <a type='link' onClick={resendVerificationCode}>
                            {` Reenviar código`}
                        </a>
                    </Spin>
                </div>
            </ForgotPasswordFormStep>
        </>
    );
};
export default VerificationCodeForm;
